
import "@/styles/pages/onlineVideoConverter/index.css";
import registerViewer from "@/components/viewer";
import registerVideoViewer from "@/components/videoViewer";
import registerOpenVideo from "@/components/openVideo";
import registerSlider from "/framework/components/slider";
import registerFit from "@/components/fit";
import registerLearnMore from "@/components/learnMorePackUp";
import registerCountedShare from "@/components/countedShare";
import registerOurDomain from "@/components/ourDomain";
import registerStartRecord from "@/components/startRecord";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // free-online-video-converter
// /free-online-video-converter.php
new Vue({
  created($, apower, LazyLoad) {
    registerOurDomain($, apower);
    $.register = $.registerComponent;
    window.apowerTrans = window.$apTranslations;
    window.apower = apower;
    apower.agents = {};
    if (!apower.getDownloadDomain) {
      apower.getDownloadDomain = function (lang) {
        lang = lang || apower.lang;

        switch (lang) {
          case "zh":
            return "https://download.apowersoft.cn";

          default:
            return "https://download.apowersoft.com";
        }
      };
    }

    function loadApiScript() {
      let url =
        "https://api.apowersoft.com/video-converter?apower=1&css=0&lang=" +
        apower.lang;
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.body.appendChild(script);
    }

    if (!$.env.isMobile) {
      loadApiScript();
    }
    registerViewer($, apower);
    registerVideoViewer($, apower);
    registerOpenVideo($, apower);
    registerSlider($, apower);
    registerFit($, apower);
    registerCountedShare($, apower);
    registerLearnMore($, apower);
    registerStartRecord($, apower);
    //for toggle first screen
    $.registerOnce({
      checkCount: 0,

      init: function () {
        this.mainEl = $(".main");
        this.themes = ["brown", "purple"];
        this.lastTheme = this.themes[0];
        setInterval($.blockFn(this.toggleScreen.bind(this)), 5000);
      },

      toggleScreen: function () {
        if (this.mainEl.is(":visible")) {
          if (++this.checkCount >= 2) {
            this.checkCount = 0;

            this.mainEl.removeClass("main-theme-" + this.lastTheme);
            var lastThemeIndex = this.themes.indexOf(this.lastTheme);
            var newTheme = this.themes[lastThemeIndex + 1] || this.themes[0];

            this.mainEl.addClass("main-theme-" + newTheme);

            this.lastTheme = newTheme;
          }
        }
      },
    });

    var operationstep = $.registerOnce({
      ref: {
        stepEl: ".operation-step",
        funBtns: ".operation-step .step-btn",
        funEls: ".step-screen .function",
      },

      anim: {},

      setfunTimeout: 0,

      init: function () {
        this.funNames = [
          "connection",
          "operation",
          "recording",
          "setting",
          "sharevideo",
        ];
        this.lastFunName = this.funNames[0];
        this.videoplay = $(".sharevideo").find(".videoplay");
        this.setanimObject();
        this.funBtns.$on("click", $.throttle(this.onBtnsClick, 500), this);
      },

      setanimObject: function () {
        for (var i = 0; i < this.funNames.length; i++) {
          var funName = this.funNames[i];
          this.anim[funName] = {
            el: this.funEls.eq(i),
          };
        }
      },

      onBtnsClick: function (e) {
        if (this.setfunTimeout) {
          clearTimeout(this.setfunTimeout);
        }

        var el = $(e.target).closest("li");
        this.funBtns.removeClass("active");
        el.addClass("active");
        var funName = el.closest("li").data("step");

        var index = $("." + funName).index();

        //close packup
        if ($(this.anim[this.lastFunName].el).find(".pack-up").is(":visible")) {
          $(this.anim[this.lastFunName].el).find(".pack-up > div").click();
        }

        this.stepEl.attr("data-step-index", index);

        if (this.lastFunName) {
          this.stepEl.removeClass("step-" + this.lastFunName);
          this.anim[this.lastFunName].el.removeClass("active");
          this.stopFunAnim();
        }

        this.stepEl.addClass("step-" + funName);
        this.anim[funName].el.addClass("active");

        var objEl = this.anim[funName].el.find(".obj-wrap");
        // objEl.dir('fit').doFit()

        // this.anim[funName].el.com().play()
        this.lastFunName = funName;
      },

      stopFunAnim: function () {
        if (this.lastFunName) {
          this.anim[this.lastFunName].el.find(".obj-wrap *").stop(true);
          // this.anim[this.lastFunName].el.find('.init-hide').hide()
          this.videoplay.trigger("pause");
        }
      },

      funTimeout: function () {
        this.setfunTimeout = 0;

        var currentIndex = this.funNames.indexOf(this.lastFunName) || 0;
        var funName = this.funNames[currentIndex + 1] || this.funNames[0];
        if (this.lastFunName) {
          this.stepEl.removeClass("step-" + this.lastFunName);
          this.anim[this.lastFunName].el.removeClass("active");
        }
        var index = $("." + funName).index();
        this.stepEl.attr("data-step-index", index);
        this.funBtns.removeClass("active");
        $(".step-btn").eq(index).addClass("active");

        var objEl = this.anim[funName].el.find(".obj-wrap");
        // objEl.dir('fit').doFit()

        this.stepEl.addClass("step-" + funName);
        this.anim[funName].el.addClass("active");

        // this.anim[funName].el.com().play()
        this.lastFunName = funName;
        this.videoplay.trigger("pause");
      },

      toggleToNextFun: function () {
        if (this.setfunTimeout) {
          clearTimeout(this.setfunTimeout);
        }

        this.setfunTimeout = setTimeout(this.funTimeout.bind(this), 5000);
      },

      throttletoggleToNextFun: function () {
        return $.throttle(this.toggleToNextFun.bind(this), 500);
      },
    });

    $.registerOnce(".mouse-scroll-down", function () {
      this.el.$on("click", function () {
        stages.scrollScreen(1);
      });
    });

    if ($.env.isSafari && $(window).width() < 768) {
      var videobtn = $("[data-video-show]").find(".video-button");
      videobtn.remove();
    }

    //for toggle screens
    var stages = $.registerOnce({
      ref: {
        screens: ".screen",
        header: ".header",
        subheader: ".subheader",
        shareEl: ".global-bottom-share",
      },

      screenIndex: 0,

      init: function () {
        var isMac = /mac/i.test(navigator.userAgent);

        if ($(window).width() > 768) {
          $(document).$on(
            "wheel",
            $.throttle(this.onWhell, isMac ? 2500 : 500),
            this
          );

          if ($.env.isTouch) {
            this.screens.onPan(this.onPanforPad, this);
          }
        } else {
          this.onMobile();
          $(document).$on(
            "scroll",
            $.blockFn(this.checkIfAnimationActive, 100),
            this
          );
        }
      },

      scrollScreen: function (newIndex, isRelative) {
        var direction = newIndex;
        var oldIndex = this.screenIndex;

        if (isRelative) {
          newIndex = this.screenIndex + newIndex;

          if (newIndex >= this.screens.length) {
            newIndex = 0;
          } else if (newIndex < 0) {
            newIndex = this.screens.length - 1;
          }
        }

        this.screenIndex = newIndex;
        var oldScreen = this.screens.eq(oldIndex);
        var newScreen = this.screens.eq(newIndex);

        if (direction === -1 || direction === 1) {
          this.screens.removeClass("last-active").removeClass("active");
          oldScreen.removeClass("active").addClass("last-active");

          if (oldScreen.is(".step-screen")) {
            operationstep.stopFunAnim();
          }
        }

        $(".video-wrap video").trigger("pause");
        $("[data-video-viewer]").find(".viewer-close").click();

        if (newScreen.is(".download-video") && $(window).width() > 768) {
          newScreen.find(".video-wrap video").trigger("play");
        }

        newScreen.addClass("active");

        if (newScreen.is(".step-screen")) {
          // operationstep.anim[operationstep.lastFunName].el.com().play()
        }

        if (
          direction == 1 ||
          this.screenIndex === 0 ||
          this.screenIndex === this.screens.length - 1
        ) {
          this.shareEl.fadeOut(200);
        } else if (direction == -1) {
          this.shareEl.fadeIn(200);
        }

        if (this.screenIndex === 0) {
          this.header.fadeIn(200);
          this.subheader.fadeOut(200);
        } else {
          this.header.fadeIn(200);
          this.subheader.fadeIn(200);

          var logo = this.subheader.find(".logo");

          logo.$on("click", this.onSubheaderLogo, this);
        }
      },

      onSubheaderLogo: function () {
        this.screens.removeClass("last-active");
        this.screens
          .eq(this.screenIndex)
          .removeClass("active")
          .addClass("last-active");
        this.screens.eq(0).addClass("active");

        this.subheader.fadeOut(200);
      },

      onWhell: function (e) {
        var screen = this.screens.eq(this.screenIndex);
        var direction = e.deltaY > 0 ? 1 : -1;

        if (screen.is(".faq-screen")) {
          var scrollTop = screen.scrollTop();
          if (direction === 1) {
            if (scrollTop + screen[0].clientHeight < screen[0].scrollHeight) {
              return;
            }
          } else {
            if (scrollTop > 0) {
              return;
            }
          }
        }

        this.scrollScreen(direction, true);
      },

      onPanforPad: function (tempDirection) {
        if (tempDirection === "t" || tempDirection === "b") {
          var direction = tempDirection === "t" ? 1 : -1;

          this.scrollScreen(direction, true);
          var screen = this.screens.eq(this.screenIndex);

          if (direction === 1) {
            this.header.fadeOut(200);
          } else if (direction === -1) {
            this.header.fadeIn(200);
          }

          if (screen.is(".step-screen")) {
            this.header.fadeOut(200);
          }

          if (this.screenIndex == 0) {
            this.header.fadeIn(200);
          }
        }
      },

      onMobile: function () {
        var moreHTML = apower.trans(
          '<div class="learn-more">' +
            "<div>{@learn_more}</div>" +
            "</div>" +
            '<div class="pack-up">' +
            "<div>{@pack_up}</div>" +
            "</div>"
        );

        $(".function .writing p").after(moreHTML);
        $.applyCom(".function .writing");
      },

      checkIfAnimationActive: function () {
        var scrollTop = $("html").scrollTop() || $("body").scrollTop(),
          windowHeight = $(window).height(),
          stepScreen = $(".step-screen"),
          top = stepScreen.offset().top,
          bot = top + stepScreen[0].offsetHeight;

        var index = stepScreen.children(".active").index(),
          funname = operationstep.funNames[index];

        if (bot <= scrollTop || top >= scrollTop + windowHeight) {
          operationstep.stopFunAnim();
          stepScreen.removeClass("active");
        } else {
          if (!stepScreen.hasClass("active")) {
            // operationstep.anim[funname].el.com().play()
          }
          stepScreen.addClass("active");
        }
      },
    });
  },
});

          })
        